<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-if="isNormal || isAgent" v-model="query.companyId" @change="companyChange"
					filterable clearable placeholder="企业" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in companys" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-select size="small" v-model="query.isUse" filterable clearable placeholder="是否开通"
					class="handle-select mr10" style="width: 140px">
					<el-option v-for="item in isUseList" :key="item.label" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-button size="mini" type="primary" :class="[theme]" icon="el-icon-search"
					@click="handleSearch">搜索</el-button>
			</div>

			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" @selection-change="handleSelectionChange"
				:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
				:cell-style="{ padding: '6px' }" stripe v-loading="loading">
				<el-table-column prop="agentName" label="代理" align="center" width="180"
					v-if="isAdmin"></el-table-column>
				<el-table-column prop="companyName" label="企业" align="center" width="180"
					v-if="isAdmin||isAgent"></el-table-column>
				<el-table-column prop="phone" label="Y号码" align="center" width="130"></el-table-column>
				<el-table-column prop="standard" label="Y号码三网制式" align="center"></el-table-column>
				<el-table-column label="归属地" align="center" width="130">
					<template #default="scope">
						<span>{{scope.row.province}}-{{scope.row.city}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="开户人姓名" align="center" width="130"></el-table-column>
				<el-table-column prop="idNo" label="开户人身份证" align="center" width="130"></el-table-column>
				<el-table-column prop="cardName" label="品牌" align="center" width="130"></el-table-column>
				<el-table-column prop="telx" label="X号码" align="center" width="130"></el-table-column>
				<el-table-column prop="telxStandard" label="X号码三网制式" align="center" width="130"></el-table-column>
				<el-table-column prop="pwd" label="密码" align="center" v-if="isAdmin" width="130"></el-table-column>
				<el-table-column prop="isUse" label="绑定坐席" align="center" width="130">
					<template #default="scope">
						<span v-if="scope.row.isUse==true">{{scope.row.steMealInfo}}</span>
						<span v-if="scope.row.isUse==false" class="red">未绑定</span>
					</template>
				</el-table-column>
				<el-table-column prop="buy" label="是否开通" align="center" width="110">
					<template #default="scope">
						<span v-if="scope.row.buy==true" class="red">未开通</span>
						<span v-if="scope.row.buy==false" style="color: #54b663;">已开通</span>
					</template>
				</el-table-column>

				<el-table-column prop="expirationTime" label="过期时间" align="center" width="160"></el-table-column>
				<el-table-column prop="isSelect" label="外呼号码" align="center">
					<template #default="scope">
						<span v-if="scope.row.isSelect==true" style="color: #54b663;">是</span>
						<span v-if="scope.row.isSelect==false" class="red">否</span>
					</template>
				</el-table-column>
				<el-table-column prop="createdAt" label="创建时间" align="center" width="160"></el-table-column>
				<el-table-column label="操作" align="center" width="240" fixed="right">
					<template #default="scope">
						<el-button size="mini" type="text" @click="getaccountEnterVisible(scope.row.id)"
							v-if="!scope.row.name&&isAdmin">录入实名</el-button>
						<el-button size="mini" type="text" @click="getbindVisible(scope.row.id)"
							v-if="scope.row.isUse==false">绑定</el-button>
						<el-button size="mini" type="text" @click="getSipAccountOccupy(scope.row)">购买</el-button>
						<el-button size="mini" type="text" @click="setAddVisible(scope.row)"
							v-if="scope.row.log?.length">查看记录</el-button>
					</template>
				</el-table-column>

			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
					:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
					@current-change="handlePageChange"></el-pagination>
			</div>
			<el-dialog title="购买记录" v-model="logVisible" width="750px" @close="closeDialog('multipleTable')">
				<el-table :data="tableData2" border class="table" ref="multipleTable" v-loading="loading"
					header-cell-class-name="table-header" :header-cell-style="{ 'text-align': 'center' }"
					:row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }" stripe>
					<el-table-column prop="opUser" label="操作人" align="center" width="120"></el-table-column>
					<el-table-column prop="type" label="操作类型" align="center" width="110"></el-table-column>
					<el-table-column prop="value" label="备注" align="center"></el-table-column>
					<el-table-column prop="opTime" label="记录时间" align="center" width="160"></el-table-column>
				</el-table>
			</el-dialog>
			<el-dialog title="支付" v-model="payVisible" width="450px" @close="closeDialog('payForm')">
				<el-form :model="payForm" :rules="payForm" ref="payForm" label-width="100px">
					<el-form-item prop="type" label="充值类型">
						<el-radio-group v-model="payForm.type" @change="typeChange">
							<el-radio label="wxpay" value="wxpay">微信</el-radio>
							<el-radio label="alipay" value="alipay">支付宝</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="扫码支付" v-show="payUrl">
						<div id="qrcode" ref="qrcode" style="position: relative;"></div>
						<div>
							<img src="../assets/img/wxpay.png" v-if="wxpayUrl" alt=""
								style="position: absolute;top: 46px;left:44px;width: 42px;height: 42px;" />
						</div>
						<div>
							<img src="../assets/img/alipay.png" v-if="alipayUrl" alt=""
								style="position: absolute;top: 46px;left:44px;width: 42px;height: 42px;" />
						</div>
					</el-form-item>
					<el-form-item class="dis-end">
						<el-button size="small" type="primary" :class="[theme]"
							@click="addRecordLabel('form')">生成二维码</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
			<el-dialog title="绑定" v-model="bindVisible" width="450px" @close="closeDialog('bindForm')">
				<el-form :model="bindForm" :rules="bindForm" ref="bindForm" label-width="100px">
					<el-form-item prop="type" label="绑定类型">
						<el-radio-group v-model="bindForm.type">
							<el-radio label="bind" value="bind">绑定</el-radio>
							<el-radio label="unbind" value="unbind">解绑</el-radio>
						</el-radio-group>
					</el-form-item>
					<div v-if="bindForm.type=='bind'">
						<el-form-item prop="phone" label="号码" v-if="phoneList.length">
							<el-radio-group v-model="bindForm.phone">
								<el-radio v-for="item in phoneList" :key="item.phone" :label="item.phone"
									:value="item.phone" style="margin-bottom: 6px;">{{ item.phone }} 已绑定
									{{item.accountCount}} 次</el-radio>
							</el-radio-group>
						</el-form-item>
					</div>
					<el-form-item class="dis-end">
						<el-button size="small" @click="closeDialog('bindForm')">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]"
							@click="getbindSetMealAccount">确认</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
			<el-dialog title="实名认证" v-model="accountEnterVisible" width="450px"
				@close="closeDialog('accountEnterForm')">
				<el-form :model="accountEnterForm" ref="accountEnterForm" label-width="100px">
					<el-form-item prop="name" label="姓名">
						<el-input size="small" v-model="accountEnterForm.name" clearable placeholder="请输入姓名"></el-input>
					</el-form-item>
					<el-form-item prop="idNo" label="身份证号">
						<el-input size="small" v-model="accountEnterForm.idNo" clearable
							placeholder="请输入身份证号码"></el-input>
					</el-form-item>
					<el-form-item prop="telx" label="X号码">
						<el-input size="small" v-model="accountEnterForm.telx" clearable
							placeholder="请输入X号码"></el-input>
					</el-form-item>
					<el-form-item prop="telxStandard" label="制式">
						<el-select size="small" v-model="accountEnterForm.telxStandard" filterable clearable
							placeholder="请选择制式" style="width: 100%;">
							<el-option v-for="item in standardList" :key="item.label" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="dis-end">
						<el-button size="small" @click="closeDialog('accountEnterForm')">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]"
							@click="getsipAccountEnter">确定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		fetchDepartment
	} from '../api/index.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		sipAccountList,
		sipAccountOccupy,
		sipAccountOccupyOrder,
		sipAccountOrderQuery,
		bindQuery,
		bindSetMealAccount,
		sipAccountEnter
	} from '../api/setMeal.js';
	import QRCode from 'qrcodejs2';
	export default {
		name: 'sipNumber',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					companyId: '',
					agentId: '',
					isUse: null,
					pageIndex: 1,
					pageSize: 10,
				},

				agents: [],
				companys: [],
				tableData: [],
				isAdmin: false,
				isAgent: false,
				isNormal: false,
				pageTotal: 0,
				isUseList: [{
					value: true,
					label: '已开通',
				}, {
					value: false,
					label: '未开通',
				}],
				standardList: [{
					value: '移动',
					label: '移动',
				}, {
					value: '联通',
					label: '移动',
				}, {
					value: '电信',
					label: '电信',
				}],

				logVisible: false,
				tableData2: [],
				payForm: {
					type: 'wxpay',
				},
				payVisible: false,
				payUrl: false,
				wxpayUrl: false,
				alipayUrl: false,
				clearInterval: null,


				bindVisible: false,
				bindForm: {
					type: 'bind',
					phone: '',
					ids: '',
					userId: localStorage.getItem('user'),
				},
				phoneList: [],
				accountEnterVisible: false,
				accountEnterForm: {
					id: '',
					name: '',
					idNo: '',
					telx: '',
					telxStandard: '',
				}
			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			this.init();
			if (this.role === 'admin') {
				this.isAdmin = true;
				this.isNormal = true;
			}
			if (this.role == 'agent') {
				this.isAgent = true;
				this.isNormal = true;
			}
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getsipNumberData();
				this.getfetchDefaultCompanies();
			},
			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					if (this.role == 'company' || this.role == 'department') {
						let data = {
							companyId: '',
							currentUserId: localStorage.getItem('user')
						};
						fetchDepartment(data).then(res => {
							this.departments = res.data;
						});
					} else {
						this.companys = res.data;
					}
				});
			},
			getsipNumberData() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query.agentId,
					companyId: this.query.companyId,
					isUse: this.query.isUse,
					pageIndex: this.query.pageIndex,
					pageSize: this.query.pageSize,
				};
				this.loading = true;
				sipAccountList(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				this.query.companyId = '';
				this.query.departmentId = '';
				this.query.userId = '';
				this.query.packageMinutes = '';
				this.packageList = [];
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				} else {
					this.departments = [];
				}
			},

			companyChange(companyId) {
				this.query.companyId = companyId;
				this.query.departmentId = '';
				this.query.userId = '';
				this.query.packageMinutes = '';
				this.packageList = [];
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
					this.query.pageIndex = 1;
				});
			},
			// 触发搜索按钮
			handleSearch() {
				this.query.pageIndex = 1;
				this.getsipNumberData();
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getsipNumberData();
			},
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getsipNumberData();
			},
			setAddVisible(row) {
				this.logVisible = true;
				this.tableData2 = row.log;
			},
			getSipAccountOccupy(row) {
				this.payForm.id = row.id;
				this.payForm.type = 'wxpay';
				let data = {
					ids: this.payForm.id,
					userId: localStorage.getItem('user')
				};
				sipAccountOccupy(data).then(res => {
					if (res?.code === 200) {
						if (res.customData) {
							this.payVisible = true;
							this.wxpayUrl = false;
							this.alipayUrl = false;
							this.payUrl = false;
							this.payForm.type = 'wxpay'
							if (this.$refs.qrcode) {
								this.$refs.qrcode.innerHTML = '';
							}
						} else {
							this.getsipNumberData();
							this.$message.success(res.message);
						}
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog(formName) {
				this.logVisible = false;
				this.payVisible = false;
				this.bindVisible = false;
				this.accountEnterVisible = false;
				clearInterval(this.clearInterval);
			},
			typeChange(e) {
				this.$refs.qrcode.innerHTML = '';
				this.payForm.type = e;
				this.payUrl = false;
				clearInterval(this.clearInterval);
			},
			addRecordLabel() {
				this.$refs.qrcode.innerHTML = '';
				this.wxpayUrl = false;
				this.alipayUrl = false;

				let data = {
					ids: this.payForm.id,
					userId: localStorage.getItem('user'),
					type: this.payForm.type,

				}
				sipAccountOccupyOrder(data).then(res => {
					if (res?.code === 200) {
						this.payUrl = true;
						this.payData = res.data;
						if (this.payForm.type == 'wxpay') {
							this.wxpayUrl = true;
							this.qr = new QRCode('qrcode', {
								width: 130,
								height: 130, // 高度
								text: this.payData.url, // 二维码内容
								colorDark: '#000000',
								colorLight: '#ffffff'
							});
						} else if (this.payForm.type == 'alipay') {
							this.alipayUrl = true;
							this.qr = new QRCode('qrcode', {
								width: 130,
								height: 130, // 高度
								text: this.payData.qrCode, // 二维码内容
								colorDark: '#000000',
								colorLight: '#ffffff'
							});
						}
						this.clearInterval = setInterval(res => {
							let data = {
								out_trade_no: this.payData.out_trade_no
							};
							sipAccountOrderQuery(data).then(res => {
								if (res?.code === 200) {
									if (res.data == true) {
										this.$message.success('支付成功');
										this.$refs.qrcode.innerHTML = '';
										this.payUrl = false;
										this.$router.go(0);
										clearInterval(this.clearInterval);
									}
								} else {
									this.$message.error(res.message);
								}
							});
						}, 2000);
					} else {
						this.$message.error(res.message);
					}
				});
			},

			getbindVisible(id) {
				this.bindVisible = true;
				this.bindForm.ids = id;
				let data = {
					companyId: this.query.companyId,
					userId: localStorage.getItem('user')
				};
				bindQuery(data).then(res => {
					if (res?.code === 200) {
						this.phoneList = res.data;
						this.getsipNumberData()
					} else {
						this.$message.error(res.message);
					}
				});
			},

			getbindSetMealAccount() {
				let data = {
					type: this.bindForm.type,
					phone: this.bindForm.phone,
					ids: this.bindForm.ids,
					userId: localStorage.getItem('user')
				};
				bindSetMealAccount(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.bindVisible = false;
						this.getsipNumberData()
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getaccountEnterVisible(id) {
				this.accountEnterForm.id = id;
				this.accountEnterForm.name = '';
				this.accountEnterForm.idNo = '';
				this.accountEnterForm.telx = '';
				this.accountEnterForm.telxStandard = '';
				this.accountEnterVisible = true;
			},
			getsipAccountEnter() {
				let data = {
					name: this.accountEnterForm.name,
					idNo: this.accountEnterForm.idNo,
					telx: this.accountEnterForm.telx,
					id: this.accountEnterForm.id,
					telxStandard: this.accountEnterForm.telxStandard,
					userId: localStorage.getItem('user')
				};
				sipAccountEnter(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.accountEnterVisible = false;
						this.getsipNumberData()
					} else {
						this.$message.error(res.message);
					}
				});
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 8px 16px;
		font-size: 12px;
		border-radius: 4px;
		margin-left: 10px;

		display: inline-block;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.grid-con-icon {
		font-size: 50px;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #fff;
	}

	.grid-cont-right {
		flex: 1;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #999;
	}

	.grid-content {
		display: flex;
		align-items: center;
		height: 100px;
	}
</style>
<style>
	.import-visible .el-upload {
		width: 100% !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
	}
</style>